<template>
  <section>
    <el-drawer
      :close-on-press-escape="false"
      @keydown.native.esc="handleCancel"
      :wrapperClosable="false"
      title="选择参与人"
      :visible.sync="selectMemberVisible"
      direction="rtl"
      :modal="false"
      size="700px"
    >
      <section v-loading="treeLoading" class="drawer-wrapper">
        <div class="drawer-wrapper-head">
          <el-input
            clearable
            placeholder="输入机构名、用户名、手机号进行过滤"
            v-model="filterText"
          >
          </el-input>
        </div>
        <div class="drawer-wrapper-body">
          <el-tree
            :show-checkbox="true"
            style="height: 75%"
            class="filter-tree"
            :data="treeData"
            node-key="id"
            :props="defaultProps"
            :filter-node-method="filterNode"
            @check="handleTreeNodeCheck"
            @node-click="handleNodeClick"
            ref="tree"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span
                v-if="data.isMember"
                class="member-tree-node"
                @click="handleCheckNode(node, data)"
              >
                <span>{{ data.deptName }}</span>
                <span class="member-name">{{ data.name }}</span>
              </span>
              <span v-else>{{ node.label }}</span>
            </span>
          </el-tree>
          <div class="member-list">
            <div class="member-items-wrapper">
              <div
                class="member-item"
                :title="`${member.deptName} : ${member.name}`"
                v-for="(member, index) of members"
                :key="member.id"
              >
                <i
                  class="el-icon-remove"
                  @click="handleRemoveMember(member, index)"
                ></i>
                <div
                  class="member-avatar"
                  :style="
                    `background-image: url(${avatarPre}/${member.avatar})`
                  "
                ></div>
                <div class="member-name">
                  {{ member.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="drawer-wrapper-footer">
          <el-pagination
            @current-change="handleChangePage"
            @size-change="handleSizeChange"
            layout="sizes, prev, pager, next"
            :current-page.sync="pagination.currentPage"
            :page-size="pagination.pageSize"
            :total="pagination.total"
          >
          </el-pagination>
          <div class="footer-expand">
            <common-button image @click="handleClickSure">确定</common-button>
            <common-button image type="cancel" @click="handleCancel"
              >取消</common-button
            >
          </div>
        </div>
      </section>
    </el-drawer>
  </section>
</template>

<script>
import cookie from "@/utils/cookie";
import http from "@/utils/axios";

export default {
  name: "ParticipantDrawer",
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "label"
      },
      filterText: null,
      finalMemberData: [],
      treeData: [],
      treeDataCopy: [],
      memberData: [],
      selectMemberVisible: false,
      dialogData: {},
      isLoading: false,
      treeLoading: false,
      loadingText: "保存中",
      avatarPre: window.config.avatar.baseUrl,

      //记录所有参与人的节点信息
      allCheckNode: [],
      allCheckNodeCopy: [],
      currentKey: [],
      flag: false,
      all: [],
      searchTimeout: null,

      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },

      //参与人
      members: [],
      //用于回显数据
      membersCopy: []
    };
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    filterText(val) {
      //触发过滤
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = null;
      }
      this.searchTimeout = setTimeout(() => {
        this.pagination.currentPage = 1;
        this.getAllDepartAndMember();
      }, 500);
    },

    visible(newVal) {
      this.selectMemberVisible = newVal;
      if (newVal) {
        //调用回显页面的数据
        this.reshowPage();
      }
    },

    //更新外面传入的值
    selectMemberVisible(newVal) {
      this.$emit("update:visible", newVal);
    }
  },

  mounted() {
    this.getAllDepartAndMember();
  },

  methods: {
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.handleChangePage(1);
    },

    reshowPage(reshowData) {
      let reshowKeys = [];
      let nodeCopy = reshowData || this.membersCopy;
      for (let node of nodeCopy) {
        this.recursionReshow(node, reshowKeys);
      }
      this.$nextTick(() => {
        //设置node节点回显数据
        this.$refs.tree.setCheckedKeys(reshowKeys);
      });
    },

    /**
     * 递归回显数据
     * @param parentNode 父节点
     * @param reshowKeys 需要回显的keys
     */
    recursionReshow(parentNode, reshowKeys) {
      if (parentNode.isMember) {
        reshowKeys.push(parentNode.id);
      } else {
        if (!parentNode.children || parentNode.children.length === 0) {
          let obj = {};
          obj.count = 0;
          //递归统计节点中人的个数
          this.recursionCount(parentNode, obj);
          //如果人不为0个 则回显数据
          if (obj.count) {
            reshowKeys.push(parentNode.id);
          }
        } else {
          for (let parent of parentNode.children) {
            this.recursionReshow(parent, reshowKeys);
          }
        }
      }
    },

    handleCancel() {
      this.members = JSON.parse(JSON.stringify(this.membersCopy));
      this.selectMemberVisible = false;
    },

    //因为需要筛选出过滤的父节点以及其所有子节点,只调用element-ui自带的方法只会返回对应的数据,因此需要进行改造筛选条件
    filterNode(value, data, node) {
      if (!value) return true;
      let _array = []; //这里使用数组存储 只是为了存储值。
      this.getReturnNode(node, _array, value);
      let result = false;
      _array.forEach(item => {
        result = result || item;
      });
      return result;
    },
    getReturnNode(node, _array, value) {
      let isPass = false;
      if (node.data) {
        if (node.data.label) {
          isPass = node.data.label.indexOf(value) !== -1;
        } else {
          isPass =
            node.data.name.indexOf(value) !== -1 ||
            node.data.phone.indexOf(value) !== -1;
        }
      }
      isPass ? _array.push(isPass) : "";
      if (!isPass && node.level != 1 && node.parent) {
        this.getReturnNode(node.parent, _array, value);
      }
    },

    async handleChangePage(page) {
      this.pagination.currentPage = page;
      await this.getAllDepartAndMember();
      this.reshowPage(this.members);
    },

    handleClickSure() {
      this.treeDataCopy = JSON.parse(JSON.stringify(this.treeData));
      this.membersCopy = JSON.parse(JSON.stringify(this.members));
      this.$emit(
        "callback",
        /*JSON.parse(JSON.stringify(this.allCheckNode))*/ null,
        JSON.parse(JSON.stringify(this.members))
      );
      this.selectMemberVisible = false;
    },

    /**
     * 修改节点的选中的状态
     */
    handleCheckNode(node, data) {
      let allCheckedValues = this.$refs.tree.getCheckedKeys([data.id]);
      if (allCheckedValues.includes(data.id)) {
        allCheckedValues = allCheckedValues.filter(item => {
          return item !== data.id;
        });
      } else {
        allCheckedValues.push(data.id);
      }
      this.$refs.tree.setCheckedKeys(allCheckedValues);
      let checkedNodes = this.$refs.tree.getCheckedNodes(false, true);
      let halfCheckedNodes = this.$refs.tree.getCheckedNodes(false, false);
      this.handleTreeNodeCheck(data, {
        checkedNodes: checkedNodes,
        halfCheckedNodes: halfCheckedNodes
      });
    },

    /**
     * 节点的状态改变时触发
     * @param node 当前被选中或取消选中的节点
     * @param checkedNodes 所有被选中的节点
     * @param halfCheckedNodes
     */
    handleTreeNodeCheck(node, { checkedNodes, halfCheckedNodes }) {
      debugger;
      let result = [];
      this.getMemberData(node, result);
      for (const member of result) {
        let flag = this.isExistMember(member);
        //存在删除
        if (flag) {
          //只有半选状态下和全选状态下没有才删除
          if (
            !checkedNodes.includes(node) &&
            !halfCheckedNodes.includes(node)
          ) {
            let members = this.members;
            for (let i = 0; i < members.length; i++) {
              if (member.id === members[i].id) {
                this.members.splice(i, 1);
                break;
              }
            }
          }
          //不存在添加
        } else {
          this.members.push(member);
        }
      }
    },

    //是否存在该用户的信息
    isExistMember(member) {
      for (let item of this.members) {
        if (item.id === member.id) {
          return true;
        }
      }
      return false;
    },

    //获取用户的信息,返回members数组
    getMemberData(node, result = []) {
      if (node.isMember) {
        result.push(node);
      } else {
        if (node.children && node.children.length) {
          let children = node.children;
          for (const child of children) {
            this.getMemberData(child, result);
          }
        }
      }
    },

    recursionCount(item, obj) {
      if (item.isMember) {
        obj.count++;
      } else {
        if (item.children) {
          for (let i = 0; i < item.children.length; i++) {
            this.recursionCount(item.children[i], obj);
          }
        }
      }
    },

    //获取树的数据
    getAllDepartAndMember() {
      let _this = this;
      _this.treeLoading = true;
      _this.treeData = [];
      let token = cookie.getCookie("token");
      http
        .post(
          window.config.api.baseUrl +
            "/eims-api/discuss/findAllDepartAndMember",
          {
            token: token,
            data: {
              pageNum: this.pagination.currentPage,
              pageSize: this.pagination.pageSize,
              keyword: this.filterText
            }
          }
        )
        .then(response => {
          if (response.data.code === "00000") {
            let tempTreeData = response.data.data.trees;
            this.pagination.total = response.data.data.total;
            _this.packagingMemberDeptData(tempTreeData);
            _this.treeData = tempTreeData;
            this.$nextTick(() => {
              if (this.filterText) {
                this.$refs.tree.filter(this.filterText);
              }
            });
          }
        })
        .finally(() => {
          _this.treeLoading = false;
        });
    },

    /**
     * 递归查找最后一层的机构(科室)的数据,将最后一层的机构(科室)拼接上用户的信息
     * @param allData
     */
    packagingMemberDeptData(allData) {
      for (let data of allData) {
        //设置上节点的id,为了用于回显
        data.id = data.value;
        if (data.children) {
          this.packagingMemberDeptData(data.children);
          if (data.addressBooks) {
            for (let addressBook of data.addressBooks) {
              if (addressBook.departmentId === data.id) {
                data.children.push({ ...addressBook, isMember: true });
              }
            }
          }
        } else {
          //设置为最后一层的机构(医院/科室)
          data.endDeptNode = true;
          //最后一层的数据
          if (data.addressBooks) {
            data.children = [];
            for (let addressBook of data.addressBooks) {
              data.children.push({ ...addressBook, isMember: true });
            }
          }
        }
      }
    },

    //获取节点数据以及节点
    handleNodeClick(data, node) {
      this.deptValue = data.value;
      if (data) {
        let num = 0; //成员数据数量
        //如果有成员
        if (data.addressBooks) {
          this.memberData = data.addressBooks;
          num = data.addressBooks.length;
        } else {
          this.memberData = [];
        }
      }
    },
    handleRemoveMember(member, index) {
      this.$refs.tree.setChecked(member, false);
      this.members.splice(index, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.drawer-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  .drawer-wrapper-head {
    margin: 10px 0;
  }

  .drawer-wrapper-body {
    flex: 1;
    overflow: auto;
    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
      .member-name {
        color: #0d8efa;
      }
    }
    .member-list {
      margin: 10px;
      height: 21%;
      overflow: auto;
      .member-items-wrapper {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        .member-item {
          position: relative;
          width: 50px;
          margin: 2px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          i {
            cursor: pointer;
            position: absolute;
            right: 0;
            top: 0;
          }
          .member-avatar {
            width: 45px;
            height: 45px;
            background-size: cover;
            border: #e8e6e6 2px solid;
            border-radius: 8px;
            align-self: center;
          }
          .member-name {
            width: 50px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            text-align: center;
          }
        }
      }
    }
  }

  .drawer-wrapper-footer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    & > * {
      margin: 5px 10px;
      display: flex;
      flex-direction: row;
      justify-content: center;
    }
    .footer-expand > * {
      margin-right: 5px;
    }
  }
}

/* tree的图标 */
/deep/ .el-icon-caret-right:before {
  content: "\e6e0";
}

/* tree的字号 */
/deep/ .el-tree-node__content span {
  font-size: 18px;
}

/deep/ .el-tree-node__content {
  height: 45px;
  font-weight: 400;
}

/* tree的滚动条 */
/deep/ .el-tree {
  width: 100%;
  overflow: scroll;
}

/deep/ .el-tree > .el-tree-node {
  display: inline-block;
  min-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/detail/ParticipantDrawer.vue